import React from 'react';

import { IconWrapper } from '../styled-components';
import { ReactComponent as downa_arrow } from './downArrow.svg';
import styled from "styled-components";
const Down_arrowIcon = styled(downa_arrow)`
  
`

type Down_arrowLogoProps = {
  scale?: number;
  altText: string;
};

const DownArrow: React.FC<Down_arrowLogoProps> = ({ scale = 1, altText }) => {
  return (
    <IconWrapper width={2 * scale} height={2 * scale} aria-label={altText} style={{"width": "1rem", marginTop: '-1px'}}>
      <Down_arrowIcon/>
    </IconWrapper>
  );
};

export default DownArrow;